/* eslint-disable no-console */
const localeUtils = require('utils/LanguageLocale');

const transformConstructorResponseForCarousel = recommendations => {
    var results = [];
    recommendations.forEach(recommendation => {
        const recommendationData = recommendation.data;
        const transformedRecommendation = {
            badgeAltText: recommendationData.currentSku.imageAltText,
            biExclusiveLevel: recommendationData.currentSku.biExclusivityLevel,
            brandName: recommendationData.brandName,
            starRatings: recommendationData.rating,
            size: recommendationData.size,
            productReviewCount: recommendationData.totalReviews,
            image: recommendationData.image_url,
            isAppExclusive: recommendationData.isAppExclusive,
            isBiOnly: recommendationData.currentSku.isBI,
            isFirstAccess: recommendationData.currentSku.isFirstAccess,
            isFree: recommendationData.currentSku.isFree,
            isLimitedEdition: recommendationData.currentSku.isLimitedEdition,
            isLimitedQuantity: recommendationData.currentSku.isLimitedQuantity,
            isLimitedTimeOffer: recommendationData.currentSku.isLimitedTimeOffer,
            isNew: recommendationData.currentSku.isNew,
            isOnlineOnly: recommendationData.currentSku.isOnlineOnly,
            isOutOfStock: recommendationData.currentSku.isOutOfStock,
            isSephoraExclusive: recommendationData.currentSku.isSephoraExclusive,
            listPrice: convertPrice(recommendationData.listPrice),
            salePrice: convertPrice(recommendationData.salePrice),
            valuePrice: convertPrice(recommendationData.valuePrice),
            wholeSalePrice: convertPrice(recommendationData.wholesalePrice),
            productId: recommendationData.id,
            productName: recommendation.value,
            skuId: recommendationData.currentSku.skuId,
            skuImages: {
                imageUrl: recommendationData.image_url
            },
            smallImage: recommendationData.currentSku.skuImages.image50,
            targetUrl: recommendationData.url,
            variationType: recommendationData.currentSku.variationValue,
            variationTypeDisplayName: recommendationData.currentSku.variationValue,
            variationValue: recommendationData.currentSku.variationValue,
            highlights: recommendationData.facets.filter(facet => facet.name === 'Ingredient Preferences')[0]?.values || []
        };

        results.push(transformedRecommendation);
    });

    return results;
};

const convertPrice = price => {
    if (price) {
        const convertedPrice = `${price.replaceAll('.', ',').replaceAll('$', '').replaceAll('-', '$ -')} $`;

        return localeUtils.isFrench() ? convertedPrice : price;
    }

    return null;
};

const getConstructorRecommendations = (podId, params) => {
    if (global.constructorio) {
        return global.constructorio.recommendations.getRecommendations(podId, params);
    } else {
        return Promise.reject(new Error('Constructor io not initialized'));
    }
};

module.exports = {
    transformConstructorResponseForCarousel,
    getConstructorRecommendations
};
